import widgets from "styles/widgets";
import listItemStyles from "styles/list-item-styles";
import { useMouseTilt } from "hooks/mouse-tilt.hook";
import { ActionEffectDto } from "dtos/shard/action-effect.dto";

export default function ActionEffectItem(props: {
    id: string,
    actionEffect?: ActionEffectDto,
    selected: boolean,
    onClick?: (actionEffect?: ActionEffectDto) => void,
}): JSX.Element
{
    // Actions:
    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.actionEffect);
        }
    }
    const [mouseMove, mouseLeave] = useMouseTilt();

    // Styles:
    const widgetClasses = widgets();
    const listItemClasses = listItemStyles({
        create: !!props.actionEffect,
        selected: props.selected,
    });
    
    // Return Component:
    return (
        <div
            onClick={() => onClick()}
            onMouseMove={mouseMove}
            onMouseLeave={mouseLeave}
            className={`${listItemClasses.container}`}
        >
            <div className={`${listItemClasses.tile} ${widgetClasses.mouseTilt}`}>
                {props.actionEffect ? (<>
                    <div className={`${listItemClasses.title}`}>
                        <span>{props.actionEffect.name}</span>
                    </div>
                </>) : (<>
                    <div className={`${listItemClasses.title}`}>
                        <span>{props.id === "create" ? "Create New" : "No"} Action Effect</span>
                    </div>
                </>)}
            </div>
        </div>
    );
}